//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect, useRef, useState } from 'react';
import ConditionalTooltip from '../ConditionalTooltip/ConditionalTooltip';
import styled from '@emotion/styled';

export type EllipsisTooltipProps = {
  text: string;
  maxWidth?: number;
};

const EllipsisTooltip = ({ text, maxWidth }: EllipsisTooltipProps) => {
  const profileRef = useRef<any>(null);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    if (profileRef.current && maxWidth) setEnabled(profileRef.current.scrollWidth > maxWidth);
    if (!maxWidth) setEnabled(true);
  }, [maxWidth]);

  return (
    <StyledConditionalTooltip max={maxWidth} show={enabled} title={text}>
      <Ellipsis max={maxWidth} ref={profileRef}>
        {text}
      </Ellipsis>
    </StyledConditionalTooltip>
  );
};

export default EllipsisTooltip;

type MaxWidthProp = {
  max?: number;
};
const Ellipsis = styled.div<MaxWidthProp>`
  max-width: ${({ max }) => (max ? max + 'px' : '100%')};
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledConditionalTooltip = styled(ConditionalTooltip)<MaxWidthProp>`
  width: ${({ max }) => (max ? max + 'px' : '100%')};
  max-width: 100%;
`;
